module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "app-body checkin-view"
  }, [_c('img', {
    staticClass: "checkin-view__logo",
    attrs: {
      "src": require("../assets/logo.png")
    }
  }), _vm._v(" "), _c('h1', [_vm._v("Check In")]), _vm._v(" "), _c('form', {
    attrs: {
      "accept-charset": "utf-8"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('label', {
    staticClass: "lbl",
    attrs: {
      "for": "activation_code"
    }
  }, [_vm._v("\n      Gib deinen Code hier ein:\n    ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activation_code),
      expression: "activation_code"
    }],
    staticClass: "ipt ipt--big",
    attrs: {
      "type": "text",
      "name": "activation_code",
      "placeholder": "",
      "maxlength": "8",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.activation_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.activation_code = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn--big",
    attrs: {
      "type": "submit",
      "disabled": _vm.activation_code.length < 8,
      "name": "submit"
    }
  }, [_vm._v("Einchecken")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53926fd2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Checkin.vue
// module id = 214
// module chunks = 1